import {PrimaryColumn, Column, Entity, OneToOne, JoinColumn} from "typeorm"
import { NetworkHistory } from "../../interfaces/network_history";
import { RemoteSocket } from "./RemoteSocket"
import { bigint } from "../../transofrmers/BigInt"
import { CommsPlanFeatures } from "../../enumerations";

@Entity({name: "tele2_details"})
export class Tele2Details {

	// ✅ Primary ID, from Jasper
	@PrimaryColumn()
	iccid!: string;										

	// ✅ Secondary ID, from Jasper
	@Column()
	msisdn!: string

	// ✅ Secondary ID, from Jasper
	@Column()
	imsi!: string

	// ✅ Secondary ID, from Jasper
	@Column({nullable: true})
	imei!: string

	// ✅ from Jasper
	@Column()
	status!: string

	// ✅ from Jasper
	@Column()
	ratePlan!: string

	// ✅ from Jasper
	@Column()
	communicationPlan!: string

	// ✅ from Jasper
	@Column()
	accountId!: string

	// ✅ from Jasper
	@Column()
	accountCustom1!: string

	@Column()
	accountCustom2!: string

	@Column()
	accountCustom3!: string

	@Column()
	accountCustom4!: string

	@Column()
	accountCustom5!: string

	@Column()
	accountCustom6!: string

	@Column()
	accountCustom7!: string

	@Column()
	accountCustom8!: string

	@Column()
	accountCustom9!: string

	@Column()
	accountCustom10!: string

	@Column()
	customerCustom1!: string

	@Column()
	customerCustom2!: string

	@Column()
	customerCustom3!: string

	@Column()
	customerCustom4!: string

	@Column()
	customerCustom5!: string

	@Column({nullable: false, default: ""})
	custom_label!: string

	@Column({default: 0})
	ip_address!: number

	//-------------------
	// Duplicated in systems\tele2-sessiondata-consumer\src\LiveData.ts
	// push_ip_address can be removed 
	@Column({default: 0})
	push_ip_address!: number 
	//-------------------

	// Not used
	@Column({ type: "datetime", nullable: true, default: null })
	internal_last_seen!: Date | null

	@Column({ type: "datetime", nullable: true, default: null })
	date_activated!: Date | null

	// Not used
	@Column({ type: "datetime", nullable: true, default: null })
	last_session_start!: Date | null

	// Not used
	@Column({ type: "datetime", nullable: true, default: null })
	last_session_end!: Date | null

	@Column({ nullable: true })
	device_type!: string

	@Column({default:false})
	ignore_notifications!: boolean

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_data_total!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_voice_total!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	current_sms_total!: number

	// Not used
	@Column({ default:false })
	details_captured!: boolean

	@Column({ type: "double", nullable: true })
	lat!: number

	@Column({ type: "double", nullable: true })
	lon!: number

	@Column({ nullable: true })
	loc_accuracy!: number

	@Column({ type: "double", nullable: true })
	ocid_lat!: number

	@Column({ type: "double", nullable: true })
	ocid_lon!: number

	@Column({ nullable: true })
	ocid_loc_accuracy!: number

	@Column({ nullable: true })
	ocid_network!: string

	@Column({ type: "double", nullable: true })
	internal_lat!: number

	@Column({ type: "double", nullable: true })
	internal_lon!: number

	@Column({ nullable: true })
	internal_loc_accuracy!: number

	// Not used
	@Column({ nullable: true })
	internal_network!: string

	@Column({ nullable: true })
	current_network!: string;
	
	// Not used
	@Column({ type:'mediumtext', nullable: true })
	location_history!: string

	// Not used
	@Column({ nullable: true })
	current_cellid!: string

	@Column({type:'datetime', nullable: true})
	push_last_session_start!: Date | null

	@Column({type:'datetime', nullable: true})
	push_last_session_end!: Date | null

	@Column({type:'datetime', nullable: true})
	last_session_update!: Date | null

	@Column({default:false})
	online_status!: boolean

	@OneToOne(() => RemoteSocket, (rs) => rs.sim) // specify inverse side as a second parameter
	@JoinColumn()
	remote_socket!: RemoteSocket

	@Column({default:null, nullable: true})
	linked_sim_iccid!: string

	@Column({ type: 'json', nullable : true, select: false }) 
  networkHistory!: NetworkHistory[]

	@Column({default:false})
	is_fixed_ip!: boolean

	@Column({ type: 'text', nullable: true })
	lolo_device_id!: string | null

	@Column({ type: 'text', nullable: true })
	lolo_account_id!: string | null

	@Column({ nullable: true })
	t2_pg_poll_network!: string

	@Column({ nullable: true })
	t2_pg_poll_country!: string

	@Column({default:false})
	t2_pg_poll_status!: boolean

	@Column({ nullable: true, default:-1 })
	t2_pg_apn_id!: number

	@Column({ nullable: true, default:-1 })
	t2_pg_rat!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	t2_pg_uploaded!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	t2_pg_uploaded_total!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	t2_pg_downloaded!: number

	@Column({ type: "bigint", default:0, transformer:bigint })
	t2_pg_downloaded_total!: number

	@Column({ type: 'text', nullable: true })
	connectivity_alarm_email!: string | null

	@Column({default:false})
	connectivity_alarm!: boolean

	@Column({default:false})
	in_network_exclusion_cycle!: boolean

	@Column({default:false})
	in_survey_cycle!: boolean

	@Column({default:false})
	cancel_survey_cycle!: boolean

	@Column({ nullable: true })
	network_survey_config!: string

	@Column({ nullable: true })
	t2_pg_poll_network2!: string

	@Column({ nullable: true })
	t2_pg_poll_country2!: string

	@Column({default:false})
	t2_pg_poll_status2!: boolean

	@Column({default:CommsPlanFeatures.NONE})
	comms_plan_feature_status!: CommsPlanFeatures

	@Column({ type: 'text', nullable: true })
	comms_plan_previous_plan!: string | null

	@Column({ default:false })
	comms_plan_pending_cancel!: boolean
}
